import { ReactNode } from "react";
import { ProtectedRoute } from "../components/ProtectedRoute";

export interface ConditionalProtectedRouteProps {
  isProtected: boolean;
  children: ReactNode;
}

export const ConditionalProtectedRoute = ({ isProtected, children }: ConditionalProtectedRouteProps) => {
  if (isProtected) {
    return <ProtectedRoute>{children}</ProtectedRoute>;
  }

  return <>{children}</>;
};
